import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {

  transform(value: any[], column: any[], order: any): any[] {
    if (!value || order === '' || !order) { return value; } // no array
    if (value.length <= 1) { return value; } // array with only one item
    if (Array.isArray(column)) {
      const partition = _.partition(value, val => { return (val[column[0]] != null && val[column[0]] != '') || (val[column[1]] != null && val[column[1]] != '') });
      return _.concat(_.orderBy(partition[0], column.map(col => {
        return row => {
          let value = _.get(row, col);
          return value != null ? typeof (value) == 'string' ? col == 'Job' || col == 'WorkOrder' ? parseInt(_.trimStart(value)) : col == 'OverallScore' ? parseFloat(_.trimStart(value)) : _.trimStart(value.toLowerCase()) : value : ''
        }
      }), [order, order]), partition[1]);
    }
    else {
      const partition = _.partition(value, (val: any) => {
        return val[column] != null && val[column] !== '';
      });
      if (typeof (value[0][column]) == "boolean") {
        const partition2 = _.partition(value, (val: any) => {
          return val[column];
        });
        if (order == "asc")
          return _.concat(partition2[1], partition2[0]);
        else
          return _.concat(partition2[0], partition2[1]);
      } else {
        return _.concat(_.orderBy(partition[0], [val => (val[column] != null ? (typeof (val[column]) == 'string' ? (column == 'Job' || column == 'Job_Name' || column == 'WorkOrder' ? parseInt(_.trimStart(val[column])) : (column == 'OverallScore' ? parseFloat(_.trimStart(val[column])) : _.trimStart(val[column].toLowerCase()))) : val[column]) : '')], order), partition[1]);
      }
    }
  }
}
